import * as React from "react";

function SvgSortSmall(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 10l4 4 4-4M12 6L8 2 4 6"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
}

export default SvgSortSmall;
